import { useClientPortalPublicData } from './ui/hooks'

export const useClientPortalPublicPage = () => {
  const { dataClientPortalPublic } = useClientPortalPublicData()

  const caseInfo = dataClientPortalPublic?.caseInfo

  const caseNumber = caseInfo?.caseNumber

  return { caseNumber }
}
